
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 1080 1080"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"100%","height":"100%","fill":"transparent"}}),_c('rect',{attrs:{"vector-effect":"non-scaling-stroke","x":"-540","y":"-540","rx":"0","ry":"0","width":"1080","height":"1080","fill":"none","transform":"translate(540 540)"}}),_c('rect',{attrs:{"vector-effect":"non-scaling-stroke","x":"-37.459","y":"-19.416","rx":"0","ry":"0","width":"74.917","height":"38.833","transform":"matrix(12.15 0 0 5.77 540 577.31)"}}),_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":"M671.989 907.242c11.635-11.425 11.635-30.278 0-41.91L560.887 754.224c-11.438-11.43-30.29-11.43-41.926 0l-111.106 111.11c-11.43 11.631-11.43 30.484 0 41.91 16.042 15.046 60.368-17.846 99.881-33.292v154.421c0 10.834 8.82 19.65 19.65 19.65h29.691c10.834 0 19.65-8.82 19.65-19.65V875.76c37.504 16.045 77.613 45.329 95.262 31.482z"}}),_c('rect',{attrs:{"vector-effect":"non-scaling-stroke","x":"-37.46","y":"-19.415","rx":"0","ry":"0","width":"74.92","height":"38.83","transform":"matrix(12.15 0 0 5.77 540 315.46)"}}),_c('rect',{attrs:{"vector-effect":"non-scaling-stroke","x":"-37.46","y":"-19.415","rx":"0","ry":"0","width":"74.92","height":"38.83","transform":"matrix(12.15 0 0 5.77 540 52.26)"}})])
          )
        }
      }
    